module.exports = __webpack_public_path__ + "media/images/common/app_icon-898dd1a1f6187cc418bd22ba9cb35317.png";